import { useState, useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function ReferanslarPage() {
  useEffect(() => {
    // SEO Meta Tags
    document.title = 'Referanslar | Adana OSGB Mersin Hatay Osmaniye İş Sağlığı Güvenliği | ASSA';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'ASSA OSGB referansları. Adana, Mersin, Hatay, Osmaniye bölgelerinde 630+ mutlu müşteri, 32.500+ korunan çalışan. İş sağlığı ve güvenliği, iş güvenliği uzmanı, işyeri hekimi hizmetlerinde güvenilir çözüm ortağı.');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'ASSA OSGB referanslar, Adana OSGB müşteriler, Mersin OSGB referanslar, Hatay OSGB müşteriler, Osmaniye OSGB referanslar, iş sağlığı ve güvenliği referanslar');
    }

    // Canonical URL
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', 'https://www.assaosgb.com.tr/referanslar');
    }

    // Schema.org JSON-LD
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "Referanslar | ASSA OSGB",
      "description": "Adana, Mersin, Hatay, Osmaniye bölgelerinde ASSA OSGB referansları ve müşteri portföyü",
      "url": "https://www.assaosgb.com.tr/referanslar",
      "mainEntity": {
        "@type": "Organization",
        "name": "ASSA OSGB",
        "description": "630+ mutlu müşteri, 32.500+ korunan çalışan ile Adana, Mersin, Hatay, Osmaniye bölgelerinde iş sağlığı ve güvenliği hizmetleri",
        "areaServed": ["Adana", "Mersin", "Hatay", "Osmaniye"]
      }
    });
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <div className="pt-20">
        {/* Header */}
        <header className="bg-gradient-to-r from-red-900 to-red-700 text-white py-16">
          <div className="container mx-auto px-4 text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">Referanslarımız</h1>
            <p className="text-xl md:text-2xl text-red-100 max-w-3xl mx-auto">
              Türkiye'nin önde gelen şirketlerine iş sağlığı ve güvenliği hizmetleri sunuyoruz
            </p>
          </div>
        </header>

        {/* Coming Soon Section */}
        <section className="py-24">
          <div className="container mx-auto px-4">
            <div className="max-w-2xl mx-auto text-center">
              <div className="w-24 h-24 mx-auto mb-8 flex items-center justify-center">
                <i className="ri-file-list-3-line text-8xl text-red-600"></i>
              </div>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                Referanslarımız Yakında Yüklenecek
              </h2>
              <p className="text-lg text-gray-600 mb-8">
                Türkiye'nin önde gelen şirketleriyle çalışmalarımız devam ediyor. Referans listelerimiz çok yakında bu sayfada yayınlanacak.
              </p>
              <div className="inline-flex items-center gap-2 text-red-600 font-semibold">
                <i className="ri-time-line text-xl"></i>
                <span>Güncelleme için takipte kalın</span>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-16 bg-gradient-to-r from-red-900 to-red-700 text-white">
          <div className="container mx-auto px-4 text-center">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              Siz de Referanslarımıza Katılın
            </h2>
            <p className="text-xl text-red-100 mb-8 max-w-2xl mx-auto">
              İş sağlığı ve güvenliği konusunda profesyonel hizmet almak için bizimle iletişime geçin
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a href="/iletisim" className="bg-white text-red-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer">
                Teklif Alın
              </a>
              <a href="/iletisim" className="border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-red-600 transition-colors whitespace-nowrap cursor-pointer">
                İletişime Geçin
              </a>
            </div>
          </div>
        </section>
      </div>

      <Footer />
    </div>
  );
}
